import React, {useCallback, useContext, useEffect, useRef, useState} from 'react';
import "../css/GUIInstrumentRow.css";
import {getPortfolioHoldingQuantity,handleTradingsymbolClick} from '../../../services/apiService';  // Import the function to fetch querterlyHolding quantity
import ShoppingBagIcon from '@mui/icons-material/ShoppingBag';
import {handlePriceDifferenceChange} from "./InstrumentUtils";
import MoreDetailsLayout from "../../../marketwatch/gridcomponents/guiinstrumentrow/MoreDetails/MoreDetailsLayout";
import SuperStarDetailsPopup from "./SuperStarDetails/SuperStarDetailsPopup/SuperStarDetailsPopup";
import PriceDifferenceDisplay from "./PriceDifferenceDisplay";
import LastTradedPriceDisplay from "./LastTradedPriceDisplay";
import {TickProvider} from "../../../contexts/TickContext";

import "../../../marketwatch/gridcomponents/css/MoreDetails.css";
import {DataContext} from "../../../contexts/DataContext";
import {SuperStarInstrumentProvider} from "@superstar/context/SuperStarInstrumentContext";
import SuperStarHoldingsBreakdown
    from "@superstar/gridcomponents/SuperStarInstrumentrow/SuperStarDetails/SuperStarHoldingsBreakdown";


const SuperStarInstrumentRow = ({
                                    SuperStarInstrument,
                                    uniqueId,
                                    onPriceDifferenceUpdate,
                                    setLayouts,
                                    layoutIndex,
                                    superStarNameMap,
                                    oneQtrInstrument,
                                    tabID,
                                    setSuperStarInstruments
                                }) => {
    const [holdingQuantity, setHoldingQuantity] = useState(null);  // State to store querterlyHolding quantity
    const [isFetching, setIsFetching] = useState(true);  // State to track fetching status
    const [priceColor, setPriceColor] = useState('black');  // Set default color for tradingsymbol
    const [lastPriceColor, setLastPriceColor] = useState('black');  // Set default color for last-traded-price
    const rowWrapperRef = useRef(null);
    const [isAnyPopupOpen, setIsAnyPopupOpen] = useState(false);
    const {screenerURLs} = useContext(DataContext);

    // Fetch querterlyHolding quantity when the component is mounted
    useEffect(() => {
        const fetchHoldingQuantity = async () => {
            const quantity = await getPortfolioHoldingQuantity(SuperStarInstrument.instrumentEntity.tradingsymbol);
            setHoldingQuantity(quantity);
            setIsFetching(false);  // Mark as done fetching
        };

        fetchHoldingQuantity();
    }, [SuperStarInstrument.instrumentEntity.tradingsymbol]);

// Use the utility function for price difference change
    const handlePriceDifference = useCallback(handlePriceDifferenceChange(onPriceDifferenceUpdate, SuperStarInstrument.instrumentEntity), [
        SuperStarInstrument.instrumentEntity.instrumentToken,
        onPriceDifferenceUpdate
    ]);
    const closeAllPopups = () => {
        setIsAnyPopupOpen(false);  // This could be passed to all popups
    };

    return (
        <TickProvider key={uniqueId}
                      instrumentToken={SuperStarInstrument.instrumentEntity.instrumentToken}
                      uniqueId={uniqueId}>
            <SuperStarInstrumentProvider
                SuperStarInstrument={SuperStarInstrument}
                tabID={tabID}
                setLayouts={setLayouts}
                layoutIndex={layoutIndex}
                superStarNameMap={superStarNameMap}
                oneQtrInstrument={oneQtrInstrument}
                setSuperStarInstruments={setSuperStarInstruments}
                onPriceDifferenceUpdate={onPriceDifferenceUpdate}
            >
                <div className="ss-instrument-row-wrapper" ref={rowWrapperRef}>

                    <div className="superstar-instrument-row">
                        <div className="ss-instrument-row">
                            <div className="ss-instrument-info instrument-info">
                                <div className="symbol_n_exchange">
                                    <span className="tradingsymbol" style={{color: priceColor}}
                                          onClick={() => handleTradingsymbolClick(SuperStarInstrument.instrumentEntity.tradingsymbol,screenerURLs)}>
                                        {SuperStarInstrument.instrumentEntity.tradingsymbol}
                                    </span>
                                    <span
                                        className="exchange-name">{SuperStarInstrument.instrumentEntity.exchange}
                                    </span>
                                </div>

                                <PriceDifferenceDisplay
                                    instrumentToken={SuperStarInstrument.instrumentEntity.instrumentToken}
                                    setPriceColor={setPriceColor}
                                    setLastPriceColor={setLastPriceColor}  // Pass color change for last-traded-price
                                    onPriceDifferenceChange={handlePriceDifference}
                                    contextName={'TickContext'}
                                />

                                <LastTradedPriceDisplay
                                    instrumentToken={SuperStarInstrument.instrumentEntity.instrumentToken}
                                    priceColor={lastPriceColor}  // Pass the color for last-traded-price
                                    contextName={'TickContext'}
                                />

                                <div style={{width: '25px'}}>
                                    <span></span>
                                </div>
                                <div className="querterlyHolding-quantity-1">
                                    {(!isFetching && holdingQuantity !== null) ? (
                                        <span>
                                              <ShoppingBagIcon style={{ fontSize: '11px', verticalAlign: 'middle' }} />
                                                                                    {`\u00A0\u00A0${holdingQuantity}`}
                                            </span>
                                            ) : (
                                        <span className="placeholder" />
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className="superstar-details-button">
                            <SuperStarDetailsPopup
                                closeAllPopups={closeAllPopups}  // Pass the closeAllPopups function
                            />
                        </div>
                        <SuperStarHoldingsBreakdown/>
                    </div>

                    {SuperStarInstrument.instrumentEntity.isDetailsVisible && (
                        <div className="ss-more-details-layout-wrapper">
                        <MoreDetailsLayout
                            setLayouts={setLayouts}
                            instrumentToken={SuperStarInstrument.instrumentEntity.instrumentToken}
                            layoutIndex={layoutIndex}
                            rowWrapperRef={rowWrapperRef}
                        />
                        </div>
                    )}
                </div>
            </SuperStarInstrumentProvider>
        </TickProvider>
    );
};

export default SuperStarInstrumentRow;
